import { memo, useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

//Components
import Snack from "../../components/snack"
import Loader from "../../components/loader"
import NavBar from "./components/nav-bar"
import RecordCard from './components/record-card'

//Extras
import { fontType } from "../../assets/extras"
import { collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc } from "firebase/firestore"
import { db } from "../../assets/connections"
import { main } from "../../assets/coach-assets/constants/colors"

const CoachRecordInfo = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const id = location.state ? location.state.id : null
    const ref = location.state ? location.state.ref : null

    //Variables principales del componente
    const [variables, setVariables] = useState({
        ref: ref,
        id: id,
        regRef: null,
        loading: true,
        historial: [],
        show: false,
        selDate: "",
        date: new Date()
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que obtiene la direccion de la bd del historial de la clase
    const getHistory = async () => {
        await getDoc(doc(doc(db, ref), "Historial", id)).then(r => {
            getHistoryRegs(r.ref) //Obtenemos la referencia del historial de la clase
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al obtener la informacion", "error")
        })
    }
    //Funcion que obtiene las clases que se han impartido de una seleccionada clase
    const getHistoryRegs = async (regRef) => {
        let aux = []
        await getDocs(query(collection(regRef, "Historial"))).then(docs => {
            docs.docs.map(v => {
                const d = v.data()
                if (variables.id.split("-").length === 1 || variables.id.split("-")[2] === "TEMP") {
                    aux.push({
                        id: v.id,
                        nombre_clase: d.nombre_clase,
                        fecha_clase: d.fecha_clase,
                        hora_clase: d.hora_clase,
                        alumnos_clase: d.alumnos_clase,
                        jugadores_reposicion: d.jugadores_resposicion ? d.jugadores_reposicion : [],
                        clasesMuestra: d.clasesMuestra ? d.clasesMuestra : [],
                    })
                } else {
                    aux.push({
                        id: v.id,
                        nombre_clase: d.nombre_clase,
                        fecha_clase: d.fecha_clase,
                        hora_clase: d.hora_clase,
                        alumnos_clase: d.jugadores_registrados
                    })
                }
            })

            setVariables(prev => ({
                ...prev,
                regRef: regRef.path,
                historial: aux,
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que elimina el registro
    const onDeleteReg = (data, index) => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        deleteReg(data, index)
    }
    //Funcion que elimina el registro
    const deleteReg = async (data, index) => {
        await deleteDoc(doc(doc(db, variables.regRef), "Historial", data.id)).then(r => {
            updateRegs(data, index)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al borrar el registro", "error")
        })
    }
    //Funciones que actualizan las asistencias de los jugadores
    const updateRegs = async (data, index) => {

        if(data.clasesMuestra){
            data.clasesMuestra.map(async (v, i) => {
                await updateDoc(doc(db, "ClaseMuestra", v.id), {
                    asistio: false
                })
            })
        }

        data.alumnos_clase.map(async (v) => {
            await getDoc(doc(doc(db, variables.ref), "Jugador", v.id)).then(async r => {
                if(r.exists()){
                    let new_asistencias = r.data().asistencias
                    new_asistencias = new_asistencias.filter(v => v.id != data.id)

                    await updateDoc(doc(doc(db, variables.ref), "Jugador", v.id), {
                        asistencias: new_asistencias
                    })
                }
            })
        })

        if(data.jugadores_reposicion){
            data.jugadores_reposicion.map(async (v) => {
                await getDoc(doc(doc(db, variables.ref), "Jugador", v.id)).then(async r => {
                    if(r.exists()){
                        let new_asistencias = r.data().asistencias
                        new_asistencias = new_asistencias.filter(v => v.id != data.id)
    
                        await updateDoc(doc(doc(db, variables.ref), "Jugador", v.id), {
                            asistencias: new_asistencias
                        })
                    }
                })
            })
        }

        variables.historial.splice(index, 1)
        setVariables(prev => ({
            ...prev,
            loading: false
        }))
        showMessage("Registro eliminado", "success")
        
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getHistory()
        }
    }, [])

    const HeaderComponent = memo(({ variables, setVariables }) => {

        //Formatea la fecha
        const formatDate = (date) => {

            let aux = date.split("-")
            if (aux[1].length == 1) {
                aux[1] = "0" + aux[1]
            }

            return aux.join("-")
        }

        return (
            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>

                {variables.show && (
                    <input
                        type="date"
                        style={{ marginTop: 10, padding: 8, borderRadius: 5, border: "1px solid #ccc" }}
                        value={variables.date ? variables.date.toISOString().split("T")[0] : ""}
                        onChange={e => {
                            const [year, month, day] = e.target.value.split("-");

                            let aux = `${year}-${month}-${day}`;
                            const selectedDate = new Date(e.target.value);

                            setVariables(prev => ({
                                ...prev,
                                date: selectedDate,
                                selDate: formatDate(aux)
                            }));
                        }}
                    />
                )}

                <button
                    style={{
                        marginTop: 5,
                        marginBottom: 10,
                        width: "80%",
                        backgroundColor: main,
                        borderRadius: 25,
                        padding: "10px 0",
                        color: "white",
                        fontFamily: fontType.title,
                        fontSize: 16,
                        border: "none",
                        cursor: "pointer"
                    }}
                    onClick={() =>
                        setVariables(prev => ({
                            ...prev,
                            show: !prev.show
                        }))
                    }
                >
                    SELECCIONAR FECHA
                </button>

                <div style={{
                    marginBottom: 20,
                    fontSize: 18,
                    fontWeight: "bold",
                    fontFamily: fontType.text,
                    width: "100%",
                    textAlign: "center"
                }}>
                    {variables.selDate}
                </div>
            </div>

        )
    })

    const BodyComponent = memo(({ variables }) => {

        //Funcion que detecta el clic en un registro de la clase
        const onHandlePress = useCallback((data) => {
            if (variables.id.split("-").length === 1 || variables.id.split("-")[2] === "TEMP") {
                navigate("/coach/info", {
                    state: {
                        regId: data.id,
                        ref: variables.ref,
                        id: variables.id,
                        regRef: variables.regRef
                    }
                })
            } else {
                navigate("/coach/record-info/ext", {
                    state: { 
                        regId: data.id, 
                        ref: variables.ref, 
                        id: variables.id, 
                        regRef: variables.regRef 
                    }    
                })
            }
        }, [])

        return (
            <div style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>
                {
                    variables.historial.map((v, i) =>
                        <RecordCard
                            data={v}
                            delay={i}
                            onHandlePress={onHandlePress}
                            onDeleteReg={onDeleteReg}
                        />
                    )
                }
            </div>
        )
    })

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div>

                <Snack />

                <NavBar
                    title={"REGISTROS"}
                />

                <BodyComponent
                    variables={variables}
                />

            </div>
        )
}

export default CoachRecordInfo